export const footerCopy = {
  footer_customize: "Customize",
  footer_site_colours: "Site Colours",
  footer_code_font: "Code Font",
  footer_site_colours_options_system: "System",
  footer_site_colours_options_always_light: "Always Light",
  footer_site_colours_options_always_dark: "Always Dark",
}